import Header from "./Components/Pricing/Header"
import Tiers from "./Components/Pricing/Tiers"
import CTA from "./Components/CTA"

const Pricing = () => {
    return (
        <div className="select-none">
            <Header></Header>
            <Tiers></Tiers>
            <CTA></CTA>
        </div>
    )
}

export default Pricing
